<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/title" title="Link target outside of Sample">Title</span></p>
<p class="toc"><span href="#/copyrightnotice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc"><span href="#/dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-bot"><span href="#/frontmatter01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><a href="#/chapter01">Chapter One</a></p>
<p class="toc"><a href="#/chapter02">Chapter Two</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter Fifteen</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?832a1d66